import App from 'app/app.js';
import 'app/directive/LtPayOnlySummaryCtrl.js';

function LtPayOnlySummaryDirective() {
  return {
    restrict: 'E',
    scope: {
      isScrollable: '=',
      childFirstName: '@',
      totalAmount: '@',
      onSubmit: '&'
    },
    template:
      '<div ng-init="payOnlySummary.init()"> ' +
      '   <div class="summary"> ' +
      '       <div class="row submit-order"> ' +
      '           <div class="col-xs-10 col-xs-offset-1"> ' +
      '              <h6 lt-translate="PAY_ONLY_ORDER_SUMMARY" lt-translate-values="{firstName: childFirstName}"> ' +
      '              </h6> ' +
      '              <h5 lt-translate="PAY_ONLY_TOTAL"> ' +
      '              </h5> ' +
      '              <h3 class="price"><span ng-bind="totalAmount | CurrencyLocaleFilter "></span></h3> ' +
      '          </div> ' +
      '       </div> ' +
      '   </div> ' +
      '   <div class="col-xs-12"> ' +
      '       <div class="row"> ' +
      '           <a class="btn green add-to-cart" lt-translate="PAY_ONLY_SUBMIT_BUTTON" ng-disabled="totalAmount <= 0" ng-click="payOnlySummary.submitOrder()" data-test-pay-only-submit-btn></a> ' +
      '       </div> ' +
      '   </div> ' +
      '</div> ',
    controller: 'LtPayOnlySummaryCtrl',
    controllerAs: 'payOnlySummary'
  };
}

App.directive('ltPayOnlySummary', [LtPayOnlySummaryDirective]);
